import { render } from "./agreement.vue?vue&type=template&id=b864285e&ts=true"
import script from "./agreement.vue?vue&type=script&lang=ts"
export * from "./agreement.vue?vue&type=script&lang=ts"

import "./agreement.vue?vue&type=style&index=0&id=b864285e&lang=less"

import exportComponent from "/Users/coohua/shiNet/h5/privacyH5Source/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__